<template>
  <div class="step-container">
    <div class="row">
      <div class="form-group currentComponent col-xs-12">
        <label>I am in the</label>
        <label class="radio-inline" v-popover.hover="tooltips.activeComponent">
          <input type="radio" name="currentComponent" value="active"
            :checked="this.formData.currentComponent === 'active'"
            @change="setFormData({ currentComponent: 'active' })" />
          Active Component
        </label>
        <label class="radio-inline" v-popover.hover="tooltips.reserveComponent">
          <input type="radio" name="currentComponent" value="reserve"
            :checked="this.formData.currentComponent === 'reserve'"
            @change="setFormData({ currentComponent: 'reserve' })" />
          Reserve Component
        </label>
      </div>
      <div class="form-group col-xs-12">
        <label>
          and will
          <span class="text-underline" v-popover.hover="tooltips.separate">separate</span>
          or retire from the
        </label>
        <select :value="formData.endingComponent" class="form-control input-sm"
          @change="setFormData({ endingComponent: $event.target.value })">
          <option value="active">Active Component</option>
          <option value="reserve">Reserve Component</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-offset-4 col-sm-4">
        <button type="button" class="btn btn-lg btn-primary btn-block" @click="setNextStep">
          Get Started
          <i class="fa fa-caret-right" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import introductionMixin from '@/js/mixins/calculator/introduction-mixin';

export default {
  mixins: [introductionMixin],
};
</script>

<style scoped lang="scss">
@import '~@/styles/resources';

.step-container {
  background-color: $wizard-step-bg;

  @media (max-width: $screen-xs-max) {
    label {
      display: block;
      margin-bottom: 5px;
    }
  }
}

.currentComponent {
  label.radio-inline {
    text-decoration: underline;
  }
}

.form-group {
  text-align: center;

  label {
    font-weight: 400;
    color: #000;
  }
}
</style>
